/** The counts above the roster: headcount, how many are active, the
 *  contractor/full-time split (only for viewers who can see pay), and
 *  assignments still ahead. */
import { Calendar, Check, DollarSign, Users } from 'lucide-react';

import type { StaffMember } from '../../../api/staff';

import StaffStatCard from './StaffStatCard';

export default function StaffStats({ staff }: { staff: StaffMember[] }) {
  const showPaySplit = staff.some((s) => s.isSalaried !== undefined);
  const fullTime = staff.filter((s) => s.isSalaried === true).length;
  const contractors = staff.filter((s) => s.isSalaried === false).length;
  return (
    <div className={`grid ${showPaySplit ? 'grid-cols-4' : 'grid-cols-3'} gap-4 mb-6`}>
      <StaffStatCard label="Total Staff" value={staff.length} icon={Users} tone="text-moss-600" />
      <StaffStatCard
        label="Active"
        value={staff.filter((s) => s.isActive).length}
        icon={Check}
        tone="text-moss-600"
      />
      {showPaySplit && (
        <StaffStatCard
          label="Contractors / Full-time"
          value={`${contractors} / ${fullTime}`}
          icon={DollarSign}
          tone="text-water-600"
        />
      )}
      <StaffStatCard
        label="Upcoming Assignments"
        value={staff.reduce((sum, s) => sum + s.upcomingWorkshops, 0)}
        icon={Calendar}
        tone="text-clay-600"
      />
    </div>
  );
}
